import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hierarchyFilter'
})
export class HierarchyFilterPipe implements PipeTransform {
  transform(items: any, filterBy: any, havingValue: any): any[] {
    if (!items || !filterBy || !havingValue) {
      return items;
    }
    // filter items array, items which match and return true will be kept, false will be filtered out
    return items.filter((item: any) =>
      this.applyFilter(item, filterBy, havingValue)
    );
  }

  /**
   * Perform the filtering.
   */
  applyFilter(item: any, filterBy: any, havingValue: any): boolean {
    havingValue = havingValue ? this.getHaving(havingValue, filterBy) : [];
    if (havingValue.length > 0) {
      return havingValue.indexOf(item[filterBy]) >= 0;
    } else {
      return true;
    }
  }
  getHaving(data, type){
    let _output: any = [];
    for (var i=0; i<data?.length; i++) {
      if(type === 'RegionName'){
        _output.push(data[i]['RegionName']);
      }
      if(type === 'SubRegionName'){
        _output.push(data[i]['SubRegionName']);
      }
      if(type === 'ClusterName'){
        _output.push(data[i]['ClusterName']);
      }
      if(type === 'CityName'){
        _output.push(data[i]['CityName']);
      }
      if(type === 'OutletCode'){
        _output.push(data[i]['OutletCode']);
      }
    }
    return _output;
  }
}
